import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as baServices from "../../BusinessAccountsPage/services"
import * as userServices from "../../User/services"
import * as services from "../services"
import { REFERRALS_SLICE_NAME } from "./referrals.constants"

/* ------------- Invite ------------- */

export const inviteByEmail = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/invite_by_email`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.inviteByEmail(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getInviteLink = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_invite_link`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInviteLink(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Earnings ------------- */

export const getYourCommissions = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_your_commissions`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getYourCommissions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReferralsTable = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_referrals_table`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.referralsTable(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAlertsByBusinessAccountId = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_alerts_by_business_account_id`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await baServices.getAlertsChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getFaq = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_faq`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getFaq(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getTotalStatistics = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_total_statistics`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getTotalStatistics(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Overview charts ------------- */

export const getReferralsOverviewData = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_referrals_overview_data`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getReferralsOverviewData(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReferralsOverviewMainInfo = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_referrals_overview_main_info`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getReferralsOverviewMainInfo(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReferralBAOptions = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_referral_ba_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getReferralBAOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAlertsBySourceTable = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_alerts_by_source_table`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAlertsBySourceTable(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Admin ------------- */

export const getAdminStatisticBlocks = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_admin_statistic_blocks`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminStatisticBlocks(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminStatisticBlockChart = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_admin_statistic_block_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminStatisticBlockChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminTable = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_admin_table`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminTable(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const exportAdminTable = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/export_admin_table`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.exportAdminTable(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminTableAlertsChart = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_admin_table_alerts_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminTableAlertsChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminTableRewardChart = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_admin_table_reward_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminTableRewardChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getReferralBusinessAccountInfo = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_referral_business_account_info`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.getReferralBusinessAccountInfo(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAffiliateAccountInfo = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_affiliate_account_info`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await userServices.getUserInfo(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCountryCodes = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_country_codes`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.countryCodes(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Outsider (external affiliate) ------------- */

export const getOutsiderBlocks = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_outsider_blocks`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getOutsiderBlocks(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const outsiderWithdraw = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/outsider_withdraw`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.outsiderWithdraw(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // Was the saga's `extraAction`: the blocks hold the balances the withdrawal just changed.
    dispatch(getOutsiderBlocks())
    return response.data
  }
)

export const getOutsiderPayoutMethod = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_outsider_payout_method`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getOutsiderPayoutMethod(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// The legacy saga for this one was hand-written and deliberately skipped the global error
// notification - the form modal renders the failure itself. Callers read the rejected
// payload through `.unwrap()`.
export const addOutsiderPayoutMethod = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/add_outsider_payout_method`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.addOutsiderPayoutMethod(data)
    if (!response.ok) {
      return rejectWithValue(response.data)
    }
    dispatch(getOutsiderBlocks())
    dispatch(getOutsiderPayoutMethod())
    return response.data
  }
)

// Same as `addOutsiderPayoutMethod`: no global error notification by design.
export const updateOutsiderPayoutMethod = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/update_outsider_payout_method`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.updateOutsiderPayoutMethod(data)
    if (!response.ok) {
      return rejectWithValue(response.data)
    }
    dispatch(getOutsiderBlocks())
    dispatch(getOutsiderPayoutMethod())
    return response.data
  }
)

export const getOutsiderWithdrawalsHistory = createAsyncThunk(
  `${REFERRALS_SLICE_NAME}/get_outsider_withdrawals_history`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getOutsiderWithdrawalsHistory(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
